import { UserCollectionDTO } from './UserCollectionDTO'
import { UserCollectionRaw } from './UserCollectionRaw'
import { UserDTOFactory } from './UserDTOFactory'

export class UserCollectionDTOFactory {
  static fromRaw(raw: UserCollectionRaw): UserCollectionDTO {
    return new UserCollectionDTO(raw.result.map(UserDTOFactory.fromRaw), raw.total_items)
  }
}
